module.exports = __webpack_public_path__ + "static/extreme-pc-2554be7181a8d9a14c44c61076404c40.png";